<template>
	<Panel :title="'Ganador de la Quiniela'" :icon="'trophy'">
		<div class="panel-block" v-for="jugador in ganadores" :key="jugador.id">
			<article class="media">
				<div class="media-left">
					<figure class="image is-48x48" :title="jugador.name">
						<img :src="jugador.image" alt="" class="is-rounded">
					</figure>
				</div>
				<div class="media-content ganador">
					<p><strong>{{ jugador.name }}</strong></p>
					<p>{{ jugador.pivot.aciertos }} aciertos</p>
				</div>
			</article>
		</div>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'

	export default {
		components: { Panel },
		props: {
			jugadores: {
				type: Array,
				required: true
			}
		},
		name: 'GanadorQuiniela',
		computed: {
			ganadores(){
				return this.jugadores.filter(jugador => jugador.pivot.ganada === 1)
			}
		},
		data() {
			return {

			};
		},
	};
</script>

<style lang="css" scoped>
.ganador{
	font-size: 0.8em;
}
</style>
